(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-is-betslip-view.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-is-betslip-view.js');
"use strict";


const {
  betslip
} = svs.sportsbook.sbtech_api_impl;
svs.sportsbook.sbtech_api_impl.fns.requests.sbtech_isBetSlipView = () => isOpen => betslip.setIsBetslipOpen(isOpen);

 })(window);